import { Avatar, Box, Typography } from "@mui/material";
import { BCPLockOutline } from "../../utils/icons/BCPIcon";

export const AuthHeader = ({ text, subTitle }) => {
  return (
    <Box
      sx={{
        width: "100%",
        marginTop: 8,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Avatar sx={{ m: 1, bgcolor: "primary.main" }}>
        <BCPLockOutline />
      </Avatar>
      <Typography component="h1" variant="h5">
        {text}
      </Typography>
      {Boolean(subTitle) && (
        <Typography variant="caption" sx={{ textAlign: "center", mt: 1 }}>
          {subTitle}
        </Typography>
      )}
    </Box>
  );
};

export const AuthSubHeader = ({ text }) => {
  return <Typography variant="body2">{text}</Typography>;
};
